const CLOSE_DELAY_MS = 250;
const closeTimers = new WeakMap();

document.querySelectorAll('header-menu[data-solena-mega-menu="true"]').forEach((host) => {
  const imageSources = host.querySelectorAll('.solena-mega-menu__image-source-set[data-target-menu] .solena-mega-menu__image-source[data-target-category]');

  imageSources.forEach((source) => {
    const targetMenu = source.closest('.solena-mega-menu__image-source-set')?.dataset.targetMenu;
    const targetItem = host.querySelector(`[data-solena-menu-title="${CSS.escape(targetMenu || '')}"]`);
    const targetCard = targetItem?.querySelector(`.solena-mega-menu__card[data-solena-category-title="${CSS.escape(source.dataset.targetCategory)}"]`);
    const imageWrap = targetCard?.querySelector('.solena-mega-menu__image-wrap');
    const image = source.querySelector('img');
    if (!imageWrap || !image) return;

    imageWrap.replaceChildren(image.cloneNode(true));
    source.remove();
  });

  const sources = host.querySelectorAll('.solena-mega-menu__promo-source[data-target-menu]');

  sources.forEach((source) => {
    const targetItem = host.querySelector(`[data-solena-menu-title="${CSS.escape(source.dataset.targetMenu)}"]`);
    const visualGrid = targetItem?.querySelector('.solena-mega-menu__visuals');
    const promoCard = source.querySelector('.solena-mega-menu__card');
    if (!visualGrid || !promoCard) return;

    visualGrid.insertBefore(promoCard, visualGrid.firstChild);
    source.remove();

    const limit = Number(visualGrid.closest('.solena-mega-menu')?.style.getPropertyValue('--solena-mega-card-count')) || 4;
    while (visualGrid.children.length > limit) {
      visualGrid.lastElementChild?.remove();
    }
  });
});

document.addEventListener(
  'keydown',
  (event) => {
    if (event.key !== 'Escape' || !(event.target instanceof Element)) return;
    const host = event.target.closest('header-menu[data-solena-mega-menu="true"]');
    if (!host || typeof host.deactivate !== 'function') return;

    const expandedItem = host.querySelector('.menu-list__disclosure[aria-expanded="true"]')?.closest('.menu-list__list-item');
    if (!expandedItem) return;

    event.preventDefault();
    host.deactivate(event);
    expandedItem.querySelector('[ref="menuitem"]')?.focus();
  },
  true
);

document.addEventListener(
  'pointerenter',
  (event) => {
    if (!(event.target instanceof Element)) return;
    const item = event.target.closest('header-menu[data-solena-mega-menu="true"] .menu-list__list-item');
    if (!item) return;

    const timer = closeTimers.get(item);
    if (timer) window.clearTimeout(timer);
    closeTimers.delete(item);
  },
  true
);

document.addEventListener(
  'pointerleave',
  (event) => {
    if (!(event.target instanceof Element)) return;
    const item = event.target.closest('header-menu[data-solena-mega-menu="true"] .menu-list__list-item');
    if (!item || item.getAttribute('slot') === 'more') return;

    event.stopImmediatePropagation();
    const previousTimer = closeTimers.get(item);
    if (previousTimer) window.clearTimeout(previousTimer);

    const timer = window.setTimeout(() => {
      closeTimers.delete(item);
      if (item.matches(':hover, :focus-within')) return;
      const host = item.closest('header-menu');
      const activeDisclosure = item.querySelector('[ref="disclosure[]"][aria-expanded="true"]');
      if (activeDisclosure && host && typeof host.deactivate === 'function') {
        host.deactivate(event);
      }
    }, CLOSE_DELAY_MS);

    closeTimers.set(item, timer);
  },
  true
);
